import type { FunctionComponent, PropsWithChildren } from 'react';
import { Fragment, useContext, useEffect } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { useApplicationFetchers } from '../fetchers/use-application-fetchers';

export const PageWithPageViewTracking: FunctionComponent<PropsWithChildren> = (properties) => {
    const { children } = properties;
    const {
        applicationState: { location },
    } = useContext(ApplicationContext);
    const { sendTrackingEvent } = useApplicationFetchers();
    useEffect(() => {
        sendTrackingEvent({
            name: 'page-view',
            payload: {
                hash: location.hash,
                pathName: location.pathname,
                search: location.search,
            },
        });
    }, [location, sendTrackingEvent]);

    return <Fragment>{children}</Fragment>;
};
